import React from 'react'
import SignupForm from '../components/SignupForm'

const Signup = () => {
  return (
    <div className='flex flex-row items-center justify-between w-full h-screen'>
        <SignupForm />
    </div>
  )
}

export default Signup